import _Cameras from "./components/Cameras";
import _Scanner from "./components/Scanner";

export const Cameras = _Cameras;
export const Scanner = _Scanner;

export default { Cameras, Scanner };
